import { useQuery } from "@tanstack/react-query";
import type { WalletSummary } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";
import { useAuthStore } from "../../lib/stores/auth";

export function useWallet() {
  const isAuthenticated = useAuthStore((s) => s.status === "authenticated");
  return useQuery({
    queryKey: ["wallet"],
    queryFn: () => apiFetch<WalletSummary>("/wallet"),
    enabled: isAuthenticated
  });
}
